import React from 'react'

import { NotificationsServiceHelper } from '@/modules/Notifications'
import { DispatchContext } from '@/store/context'
import { FrontNotification, FrontNotificationType } from '@/data'
import { EmtAlert } from 'emt-components-v2'

type Props = {
  notification: FrontNotification
  defaultErrorDuration?: number
  defaultWarnDuration?: number
  defaultSuccessDuration?: number
  defaultDebugDuration?: number
}

const NotificationView: React.FC<Props> = ({
  notification,
  defaultErrorDuration = 8000,
  defaultWarnDuration = 2000,
  defaultSuccessDuration = 2000,
  defaultDebugDuration = 2000,
}) => {
  const dispatch = React.useContext(DispatchContext)
  React.useEffect(() => {
    const { type, timeToStay } = notification
    let tileTimeToStay = timeToStay
    if (tileTimeToStay === undefined) {
      switch (type) {
        case FrontNotificationType.ERROR:
          tileTimeToStay = defaultErrorDuration
          break
        case FrontNotificationType.SUCCESS:
          tileTimeToStay = defaultSuccessDuration
          break
        case FrontNotificationType.DEBUG:
          tileTimeToStay = defaultDebugDuration
          break
        case FrontNotificationType.WARN:
        default:
          tileTimeToStay = defaultWarnDuration
          break
      }
    }
    if (tileTimeToStay) {
      setTimeout(close, tileTimeToStay)
    }
  }, [])

  const close = () => {
    if (notification.id) {
      NotificationsServiceHelper.closeNotification(dispatch)(notification.id)
    }
  }

  const { type, id, title, message } = notification

  return <EmtAlert key={id} severity={type} sx={{ margin: 2 }} title={title} caption={message} isOpen />
}

export default NotificationView
